import "./Loading.css";

export default function Loading({show = false}) {
    return (
        <span className={'loader-kg2fkgn ms-2'+(!show ? ' d-none' : '')}></span>
    );
}